module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cs-page",
    attrs: {
      "data-testid": "chat-simulator",
      "data-theme": _vm.theme
    }
  }, [_c('div', {
    staticClass: "cs-shell",
    attrs: {
      "data-testid": "chat-shell"
    }
  }, [_c('header', {
    staticClass: "cs-header",
    attrs: {
      "data-testid": "chat-header"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cs-title"
  }, [_c('span', {
    staticClass: "cs-name"
  }, [_vm._v("Chat Simulator")]), _vm._v(" "), _c('small', {
    staticClass: "cs-sub",
    attrs: {
      "data-testid": "chat-chat-id"
    }
  }, [_vm._v(_vm._s(_vm.chatIdLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "cs-controls"
  }, [_c('label', {
    staticClass: "cs-label",
    attrs: {
      "for": "cs-country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCountryId),
      expression: "selectedCountryId"
    }],
    staticClass: "cs-select",
    attrs: {
      "id": "cs-country",
      "data-testid": "chat-country-select",
      "disabled": _vm.loadingCountries
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCountryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.loadingCountries ? 'Loading...' : 'Select country'))]), _vm._v(" "), _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.id,
      attrs: {
        "data-country-id": c.id
      },
      domProps: {
        "value": c.id
      }
    }, [_vm._v("\n          " + _vm._s(c.name) + "\n        ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "cs-icon-btn",
    attrs: {
      "type": "button",
      "data-testid": "chat-theme-btn",
      "title": "Switch to light/dark theme",
      "aria-label": _vm.theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
    },
    on: {
      "click": _vm.toggleTheme
    }
  }, [(_vm.theme === 'dark') ? _c('svg', {
    staticClass: "cs-svg",
    attrs: {
      "data-testid": "chat-theme-icon-sun",
      "viewBox": "0 0 24 24",
      "width": "20",
      "height": "20",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "4.5",
      "fill": "currentColor",
      "stroke": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"
    }
  })]) : _c('svg', {
    staticClass: "cs-svg",
    attrs: {
      "data-testid": "chat-theme-icon-moon",
      "viewBox": "0 0 24 24",
      "width": "20",
      "height": "20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.5 14.6A8.5 8.5 0 0 1 9.4 3.5a.7.7 0 0 0-1-.8A10 10 0 1 0 21.3 15.6a.7.7 0 0 0-.8-1z"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "cs-icon-btn",
    attrs: {
      "type": "button",
      "data-testid": "chat-new-btn",
      "title": "New chat (starts as a new user)",
      "aria-label": "New chat",
      "disabled": !_vm.selectedCountry || _vm.demo
    },
    on: {
      "click": _vm.newChat
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "cs-icon-btn",
    attrs: {
      "type": "button",
      "data-testid": "chat-restart-btn",
      "title": "Restart chat"
    },
    on: {
      "click": _vm.restart
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), (_vm.countryError) ? _c('div', {
    staticClass: "cs-error",
    attrs: {
      "data-testid": "chat-country-error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.countryError) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.sendError) ? _c('div', {
    staticClass: "cs-error",
    attrs: {
      "data-testid": "chat-send-error"
    }
  }, [_vm._v(_vm._s(_vm.sendError))]) : _vm._e(), _vm._v(" "), (!_vm.demo && _vm.selectedCountry && !_vm.streamOnline) ? _c('div', {
    staticClass: "cs-notice",
    attrs: {
      "data-testid": "chat-notice"
    }
  }, [_vm._v("\n    Connecting to replies...\n  ")]) : _vm._e(), _vm._v(" "), _c('main', {
    ref: "thread",
    staticClass: "cs-thread",
    attrs: {
      "data-testid": "chat-thread"
    }
  }, [(_vm.loadingHistory) ? _c('div', {
    staticClass: "cs-empty",
    attrs: {
      "data-testid": "chat-history-loading"
    }
  }, [_vm._v("Loading chat...")]) : (!_vm.messages.length) ? _c('div', {
    staticClass: "cs-empty",
    attrs: {
      "data-testid": "chat-empty"
    }
  }, [_vm._v(_vm._s(_vm.demo ? 'No messages yet.' : (_vm.selectedCountry ? 'Send a journey keyword to start.' : 'Select a country to open its chat.')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(m) {
    return _c('message-bubble', {
      key: m.msgId,
      attrs: {
        "message": m,
        "disabled": !_vm.demo && m.msgId !== _vm.activeId
      },
      on: {
        "reply": _vm.onReply,
        "location": _vm.onLocation
      }
    })
  }), _vm._v(" "), (_vm.typing) ? _c('div', {
    staticClass: "cs-typing",
    attrs: {
      "data-testid": "chat-typing"
    }
  }, [_c('span'), _c('span'), _c('span')]) : _vm._e()], 2), _vm._v(" "), (_vm.pending) ? _c('div', {
    staticClass: "cs-pending",
    attrs: {
      "data-testid": "chat-attachment-preview"
    }
  }, [(_vm.pending.kind === 'image') ? _c('img', {
    staticClass: "cs-pending-thumb",
    attrs: {
      "src": _vm.pending.url,
      "alt": "preview"
    }
  }) : (_vm.pending.kind === 'video') ? _c('video', {
    staticClass: "cs-pending-thumb",
    attrs: {
      "src": _vm.pending.url,
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('i', {
    staticClass: "fa fa-file-o cs-pending-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cs-pending-meta"
  }, [_c('span', {
    staticClass: "cs-pending-name",
    attrs: {
      "data-testid": "chat-attachment-name"
    }
  }, [_vm._v(_vm._s(_vm.pending.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.pending.sizeLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "cs-icon-btn",
    attrs: {
      "type": "button",
      "data-testid": "chat-attachment-remove",
      "title": "Remove"
    },
    on: {
      "click": _vm.clearPending
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e(), _vm._v(" "), (_vm.attachError) ? _c('div', {
    staticClass: "cs-error",
    attrs: {
      "data-testid": "chat-attachment-error"
    }
  }, [_vm._v(_vm._s(_vm.attachError))]) : _vm._e(), _vm._v(" "), (_vm.emojiOpen) ? _c('div', {
    staticClass: "cs-emoji",
    attrs: {
      "data-testid": "chat-emoji-picker"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l((_vm.emojis), function(e) {
    return _c('button', {
      key: e,
      staticClass: "cs-emoji-btn",
      attrs: {
        "type": "button",
        "data-emoji": e
      },
      on: {
        "click": function($event) {
          return _vm.insertEmoji(e)
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), 0) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "cs-footer",
    attrs: {
      "data-testid": "chat-footer"
    }
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "cs-file",
    attrs: {
      "type": "file",
      "data-testid": "chat-file-input",
      "accept": "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cs-footer-icon",
    attrs: {
      "type": "button",
      "data-testid": "chat-attach-btn",
      "title": "Attach"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.fileInput.click()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "cs-footer-icon",
    attrs: {
      "type": "button",
      "data-testid": "chat-emoji-btn",
      "title": "Emoji"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.emojiOpen = !_vm.emojiOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft),
      expression: "draft"
    }],
    ref: "input",
    staticClass: "cs-input",
    attrs: {
      "type": "text",
      "data-testid": "chat-input",
      "placeholder": _vm.pending ? 'Add a caption' : 'Type a message',
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.draft)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.draft = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cs-send",
    attrs: {
      "type": "button",
      "data-testid": "chat-send-btn",
      "title": _vm.canSend ? 'Send' : 'Voice message (not available)',
      "disabled": !_vm.canSend
    },
    on: {
      "click": _vm.send
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.canSend ? 'fa-paper-plane' : 'fa-microphone'
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cs-avatar"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1dafa724","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-simulator/ChatSimulator.vue
// module id = iMIU
// module chunks = 1